import React, { useState, useEffect } from 'react';
import Image from '../../../components/AppImage';

const API_BASE_URL = 'https://spaceportfolio-api.rajansudhan0.workers.dev';

const ClientLogos = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/settings`)
      .then(res => res.json())
      .then(data => {
        setSettings(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching settings:', err);
        setLoading(false);
      });
  }, []);

  const defaultClients = [
    {
      name: "NASA STEM Gateway",
      logo: "https://upload.wikimedia.org/wikipedia/commons/e/e5/NASA_logo.svg",
      industry: "STEM Education / Astronomy"
    },
    {
      name: "ISRO",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Indian_Space_Research_Organisation_Logo.svg/450px-Indian_Space_Research_Organisation_Logo.svg.png",
      industry: "Space Research / Remote Sensing"
    },
    {
      name: "NARL (ISRO)",
      logo: "https://media.licdn.com/dms/image/v2/C510BAQEkpuR-jeugQg/company-logo_200_200/company-logo_200_200/0/1630614913323/national_atmospheric_research_laboratory_isro_logo?e=2147483647&v=beta&t=SyNoGSJQ0LSLd5hQlj68ktHTuzB9LIlhPvr8db1Trrc",
      industry: "Atmospheric Science / Space Research"
    },
    {
      name: "IAAC 2025 - Astronomy Competition",
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSdzkU2t5eY7f_i2nI_29XUVf3BpduM5Cj4_A&s",
      industry: "International Science Outreach"
    },
    {
      name: "Vigyan Prasar - VIPNET",
      logo: "https://niascomm.in/wp-content/uploads/2020/07/Vigyan-Prasar.jpg",
      industry: "Science Communication / Public Engagement"
    },
    {
      name: "SSPI - Space & Satellite Professionals International",
      logo: "https://www.sspi.org/sites/default/files/sspi-logo.png",
      industry: "Satellite & Space Networking"
    }
  ];

  const clients = Array.isArray(settings?.client_logos) && settings.client_logos.length > 0 
    ? settings.client_logos 
    : defaultClients;

  return (
    <section className="py-12 lg:py-16 bg-surface/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8 lg:mb-12">
          <h3 className="font-heading font-semibold text-lg text-text-secondary mb-2">
            Empowering the Future of Space and Science
          </h3>
          <p className="text-text-secondary">
            Collaborated with top space agencies, research labs, and STEM institutions to advance science and innovation.
          </p>
        </div>

        {/* Client Logos Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
          {clients.map((client, index) => (
            <div
              key={index}
              className="group flex flex-col items-center justify-center p-6 bg-white/90 hover:bg-white rounded-2xl border border-white/5 shadow-lg hover:shadow-xl hover:-translate-y-1 transition-smooth cursor-pointer h-24 lg:h-28"
            >
              <div className="relative w-full h-full flex items-center justify-center">
                <Image
                  src={client.logo}
                  alt={`${client.name} logo`}
                  className="max-w-full max-h-full object-contain filter grayscale group-hover:grayscale-0 transition-smooth opacity-75 group-hover:opacity-100 mix-blend-multiply"
                />
              </div>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-12 lg:mt-16">
          {loading ? (
            <div className="col-span-4 h-16 animate-pulse bg-white/5 rounded-xl"></div>
          ) : (
             (settings?.client_stats || [
              { metric: "2+", description: "Research & Tech Projects" },
              { metric: "8+", description: "Domains Explored" },
              { metric: "5+", description: "Core Scientific Fields" },
              { metric: "2+", description: "Years Active Research Experience" }
            ]).map((stat, idx) => (
              <div key={idx} className="text-center group">
                <div className="font-heading font-bold text-2xl lg:text-3xl text-text-primary mb-1 group-hover:text-accent transition-smooth">
                  {stat.metric}
                </div>
                <div className="text-sm text-text-secondary">
                  {stat.description}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;